import { AccountBalanceWallet, AccountBox, Add, Dashboard, Edit, Inventory, Logout, Receipt, ShoppingBag } from '@mui/icons-material';
import React from 'react'
import { DrawerList } from '../../components/DrawerList';


const menu = [
    // {
    //   name: "Dashboard",
    //   path: "/seller",
    //   icon: <Dashboard className="text-primary" />,
    //   activeIcon: <Dashboard className="text-white" />,
    // },
    {
      name: "Orders",
      path: "/seller",
      icon: <ShoppingBag className="text-primary" />,
      activeIcon: <ShoppingBag className="text-white" />,
    },
    {
      name: "Products",
      path: "/seller/products",
      icon: <Inventory className="text-primary" />,
      activeIcon: <Inventory className="text-white" />,
    },
    {
      name: "Add Product",
      path: "/seller/add-product",
      icon: <Add className="text-primary" />,
      activeIcon: <Add className="text-white" />,
    },
    // {
    //   name: "Edit Product",
    //   path: "/products/edit/:productId",
    //   icon: <Edit className="text-primary" />,
    //   activeIcon: <Edit className="text-white" />,
    // },
    {
      name: "Payment",
      path: "/seller/payment",
      icon: <AccountBalanceWallet className="text-primary" />,
      activeIcon: <AccountBalanceWallet className="text-white" />,
    },
    {
      name: "Transaction",
      path: "/seller/transaction",
      icon: <Receipt className="text-primary" />,
      activeIcon: <Receipt className="text-white" />,
    },
   
  ];
  
  const menu2 = [
    {
      name: "Account",
      path: "/seller/account",
      icon: <AccountBox className="text-primary" />,
      activeIcon: <AccountBox className="text-white" />,
    },
    {
      name: "Logout",
      path: "/",
      icon: <Logout className="text-primary" />,
      activeIcon: <Logout className="text-white" />,
    },
  ];
  
export const SellerDrawerList = ({toggleDrawer}:{toggleDrawer:any}) => {
  return (
   
        <DrawerList menu={menu} menu2={menu2} toggleDrawer={toggleDrawer} />
  
  )
}
